angular.module('jv.Dashboard.WidgetList.Controller', [])
.controller('jv.Dashboard.WidgetList.Controller',
    ['$scope','jvDashboardAjaxService', 'jvContextualLoadingService', '$window', '$rootScope', 'TemplateLoader','jvDashboardFactory',
    
    function($scope, jvDashboardAjaxService, jvContextualLoadingService, $window,  $rootScope, TemplateLoader, jvDashboardFactory){

        //Handler to refresh widget instance map
        $rootScope.$on('DASHBOARD_WIDGET_INSTANCE_MAP_RESET', function(event,data) {
            if(data){
                $scope.widgetInstanceMap = data;
            }
        });

        $scope.$watch('modals.widgetList.show',function(newVal, oldVal){
            if(newVal){
                initController();
            }
        });

        //Make call to get widget list
        $scope.getWidgetList = function(pageNumber){
            jvContextualLoadingService.show('widget-list');
            $scope.currentPage = pageNumber;
            var postData = {
                'page': pageNumber,
                'pageSize': 5
            };
            jvDashboardAjaxService.getWidgetList(postData,function(response){
                jvContextualLoadingService.hide('widget-list');
                if(response.widgets && response.widgets.length){
                    $scope.widgets = response.widgets;
                    $scope.setWidgetInstanceMap();
                    $scope.totalCount = response.widgetsCount;
                }
            });
        };
        
        //Making sure we have an entry in instanceMap for each widget in the widget list
        $scope.setWidgetInstanceMap = function(){
            angular.forEach($scope.widgets,function(widget,key){
                if(!$scope.widgetInstanceMap[widget.mainType]){
                    jvDashboardFactory.setWidgetInstanceForWidget(widget.mainType,0);
                }
            });
        };

        var initController = function(){
            $scope.widgets = [];
            $scope.pageSize = 5;
            $scope.totalCount = 0;
            $scope.currentPage = 0;
            //get widgetInstanceMap
            $scope.widgetInstanceMap = jvDashboardFactory.getWidgetInstanceMap();
            $scope.getWidgetList(0);
        };

        initController();
}]);